<template>
    <div class="whatsapp-phone-container" :class="{ 'rtl': isRTL }">
      <button 
        @click="openWhatsAppChat"
        class="whatsapp-phone-btn"
        :class="{ 'pulse': isHovered }"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        aria-label="Chat on WhatsApp"
      >
        <!-- Minimal WhatsApp-style glyph -->
        <svg viewBox="0 0 24 24" class="whatsapp-icon" aria-hidden="true">
          <path d="M12 2C6.48 2 2 6.26 2 11.6c0 1.69.46 3.27 1.26 4.65L2 22l5.95-1.22c1.3.71 2.79 1.1 4.05 1.1 5.52 0 10-4.26 10-9.7S17.52 2 12 2zm0 17.4c-1.15 0-2.48-.35-3.53-.96l-.25-.15-3.52.73.74-3.34-.16-.26C4.64 14.1 4.2 12.88 4.2 11.6 4.2 7.83 7.64 4.8 12 4.8s7.8 3.03 7.8 6.8-3.49 7.8-7.8 7.8z" fill="currentColor"/>
          <path d="M15.6 13.7c-.12-.06-1.03-.49-1.2-.56-.17-.07-.29-.1-.4.04-.11.13-.45.52-.55.64-.1.12-.2.13-.37.05-.17-.08-.86-.33-1.63-.98-.7-.59-1.18-1.33-1.31-1.55-.13-.22-.01-.34.08-.45.09-.11.19-.26.28-.39.09-.14.12-.24.05-.37-.07-.13-.61-1.46-.83-1.96-.22-.5-.44-.43-.6-.44-.16-.01-.34-.02-.53-.02-.19 0-.5.07-.76.35-.26.28-.99.97-.99 2.37 0 1.4 1.01 2.75 1.16 2.94.14.19 1.98 3.02 4.84 4.26.68.29 1.2.46 1.61.59.68.22 1.3.19 1.79.12.55-.08 1.03-.47 1.17-.92.14-.45.14-.84.1-.92-.04-.08-.16-.12-.28-.18z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WhatsAppPhone',
    data() {
      return {
        isHovered: false,
        phoneNumber: '+972545888633'
      }
    },
    computed: {
      isRTL() {
        return this.$store.getters.isRTL;
      }
    },
    methods: {
      openWhatsAppChat() {
        // Format phone number for WhatsApp (remove + and spaces)
        const formattedNumber = this.phoneNumber.replace(/\+/g, '').replace(/\s/g, '');
        
        // Create WhatsApp URL
        const whatsappUrl = `https://wa.me/${formattedNumber}`;
        
        // Open in new tab
        window.open(whatsappUrl, '_blank');
      }
    }
  }
  </script>
  
  <style scoped>
  .whatsapp-phone-container {
    position: fixed;
    left: 20px;
    bottom: 20px;
    z-index: 2000;
  }
  
  .whatsapp-phone-container.rtl {
    left: auto;
    right: 20px;
  }
  
  .whatsapp-phone-btn {
    position: relative;
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 24px rgba(37, 211, 102, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #fff;
    overflow: visible;
  }
  
  .whatsapp-phone-btn:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 15px 35px rgba(37, 211, 102, 0.4);
    background: linear-gradient(135deg, #2ee477 0%, #128C7E 100%);
  }
  
  .whatsapp-phone-btn:active {
    transform: translateY(-1px) scale(1.02);
  }
  
  .whatsapp-icon {
    width: 28px;
    height: 28px;
    transition: all 0.2s ease;
  }
  
  .whatsapp-phone-btn:hover .whatsapp-icon {
    transform: scale(1.1);
  }
  
  .pulse {
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3), 0 0 0 0 rgba(37, 211, 102, 0.7);
    }
    70% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3), 0 0 0 10px rgba(37, 211, 102, 0);
    }
    100% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.3), 0 0 0 0 rgba(37, 211, 102, 0);
    }
  }
  
  /* removed message indicator for a cleaner common-floating look */
  
  /* Responsive design */
  @media (max-width: 768px) {
    .whatsapp-phone-btn {
      width: 54px;
      height: 54px;
    }
    
    .whatsapp-icon {
      width: 26px;
      height: 26px;
    }
  }
  
  /* For dashboard integration - larger size option */
  .whatsapp-phone-btn.large {
    width: 100px;
    height: 100px;
  }
  
  .whatsapp-phone-btn.large .whatsapp-icon {
    width: 50px;
    height: 50px;
  }
  </style>